import { Record } from 'immutable';
import type { RecordOf } from 'immutable';

export type InvestmentQuoteTypeV2 = {
  id?: string;

  name?: string;
  symbol?: string;
  relatedSymbol?: string;
  lastPrice?: number;
  quoteTime?: string;
  amtChange?: number;
  pctChange?: number;
  volume?: number;
  avgVolume?: number;
  openPrice?: number;
  dayHigh?: number;
  dayLow?: number;
  exchange?: string;
  eps?: number;
  closePrice?: number;
  currentPrice?: number;
  mktCap?: number;
  peRatio?: number;
  divYield?: number;
  yearHigh?: number;
  yearLow?: number;
  fiftyTwoWeekHigh?: number;
  fiftyTwoWeekHighDate?: string;
  fiftyTwoWeekLow?: number;
  fiftyTwoWeekLowDate?: string;
  previousClosePrice?: number;
  realTime?: boolean;
};

export type InvestmentQuoteV2 = RecordOf<InvestmentQuoteTypeV2>;
export const mkInvestmentQuoteV2 = Record<InvestmentQuoteTypeV2>({
  id: undefined,
  name: undefined,
  symbol: undefined,
  relatedSymbol: undefined,
  lastPrice: undefined,
  quoteTime: undefined,
  amtChange: undefined,
  pctChange: undefined,
  volume: undefined,
  avgVolume: undefined,
  openPrice: undefined,
  dayHigh: undefined,
  dayLow: undefined,
  exchange: undefined,
  eps: undefined,
  closePrice: undefined,
  currentPrice: undefined,
  mktCap: undefined,
  peRatio: undefined,
  divYield: undefined,
  yearHigh: undefined,
  yearLow: undefined,
  fiftyTwoWeekHigh: undefined,
  fiftyTwoWeekHighDate: undefined,
  fiftyTwoWeekLow: undefined,
  fiftyTwoWeekLowDate: undefined,
  previousClosePrice: undefined,
  realTime: undefined,
});
